export enum ColorType {
    SOLID, MONOCHROMATIC, MULTICOLORED
}
